<template>
	<div class="waiting">
		<svg xmlns="http://www.w3.org/2000/svg" width="26.036" height="26.036" viewBox="0 0 26.036 26.036">
			<g id="Group_22720" data-name="Group 22720" transform="translate(508.305 627.823) rotate(-158)">
				<path
					id="Path_19914"
					data-name="Path 19914"
					d="M697.427,384.5a7.9,7.9,0,0,1-7.9,7.895V394.5a10.011,10.011,0,0,0,10-10Z"
					fill="#4b78f5"
				/>
				<path
					id="Path_19915"
					data-name="Path 19915"
					d="M681.637,384.5a7.895,7.895,0,1,1,15.79,0h2.1a10,10,0,1,0-10,10v-2.105A7.9,7.9,0,0,1,681.637,384.5Z"
					fill="#c0d5fd"
				/>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'RunningSVG',
};
</script>

<style scoped lang="scss">
.waiting {
	position: relative;
	height: 30px;
	width: 30px;
	transform: translateY(-3px);

	svg {
		position: absolute;
		top: 0;
		left: 5px;
		width: 30px;

		animation-name: spin;
		animation-duration: 2000ms;
		animation-iteration-count: infinite;
		animation-timing-function: linear;

		@keyframes spin {
			from {
				transform: rotate(0deg);
			}
			to {
				transform: rotate(360deg);
			}
		}
	}
}
</style>
